import { TabButtonContainer } from "./TabButtonStyleComponents";
import { ITabButtonProps } from "./ITabButton";

export function TabButton({ text, callback }: ITabButtonProps) {
  return <TabButtonContainer onClick={callback}>{text}</TabButtonContainer>;
}
